export const getMaxCharacter = (str: string, maxChar = 100, dots = true): string =>
    str.length > maxChar ? str.slice(0, maxChar - 1) + `${dots ? '...' : ''}` : str

export const removeParenthesesContent = (str: string): string => str.replace(/ *\([^)]*\) */g, ' ')

export const removeLineBreaksInTable = (str: string): string => {
    const pattern = /(?=<table\b[^>]*>)(.*?)(?=<\/table>)/gs
    return str.replace(pattern, (match) => match.replace(/\n/g, ''))
}

export const removeLineBreaksInList = (str: string): string => {
    const pattern = /(?=<[uol]+\b[^>]*>)(.*?)(?=<\/[uol]+>)/gs
    return str.replace(pattern, (match) => match.replace(/\n/g, ''))
}

export const addBrToLiWhichContainsParagraph = (str: string): string => {
    const pattern = /(<li>.*?<p>.*?<\/p>.*?<\/li>)/g
    return str.replace(pattern, '$1<br />')
}

export const getCompletePath = (path: string): string =>
    `/${process.env.GATSBY_PATH_PREFIX}${path}`.replace(/\/\//gi, '/')

export const containsSpecialChars = (str: string): boolean => /[^a-zA-Z0-9\s]/.test(str)
